import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import FormControl from 'react-bootstrap/FormControl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';

import './index.css';

// forwardRef --> Dropdown needs access to the DOM of the Menu to measure it
const CustomToggle = React.forwardRef(({ name, onClick, buttonVariant, isButtonDisabled }, ref) => (
  <Button
    ref={ref}
    variant={buttonVariant}
    disabled={isButtonDisabled}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {name}
  </Button>
));

// forwardRef --> Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
  ({ name, data, setData, dropdownData, children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    const [value, setValue] = useState('');
    const [t] = useTranslation(); 
    const onChange = i => {
      if (data.includes(i)) {
        setData(data.filter(item => item !== i))
      } else {
        setData([...data, i].sort());
      }
    };

    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <FormControl
          autoFocus
          className="mx-2 my-2 w-auto"
          placeholder={t('multiselect.typeToFilter')}
          onChange={e => {setValue(e.target.value)}}
          value={value}
        />
        <Button
          variant="link"
          onClick={e => {
            e.preventDefault();
            setData(dropdownData);
          }}
        >
          {t('multiselect.selectAll')}
        </Button>
        -
        <Button
          variant="link"
          onClick={e => {
            e.preventDefault();
            setData([]);
          }}
        >
          {t('multiselect.clearAll')}
          </Button>
        <Form.Group controlId="formBasicCheckbox">
          {
            React.Children.toArray(children).filter(
              child => !value || child.props.children.toLowerCase().includes(value.toLowerCase())
            ).map(({ props: { children: item } }) => (
              <Form.Check 
                key={item}
                custom
                type="checkbox"
                checked={data.includes(item)}
                id={`${name}${item}`}
                label={item}
                onChange={() => {onChange(item)}}
              />
            ))
          }
        </Form.Group>
      </div>
    );
  },
);

/**
 * NOTE: name prop
 * if one renders multiple instances of this component
 * with the same values, to prevent selecting bugs,
 * name prop should be unique
 */
const MultiselectFilter = ({ dropdownData, multiselectedData, setMultiselectedData, name, buttonVariant='link', isButtonDisabled=false}) => {
  const [data, setData] = useState([]);

  return (
    <Dropdown onToggle={show => {if (!show) {setMultiselectedData(data)} else {setData(multiselectedData)};}}>
    <Dropdown.Toggle as={CustomToggle} name={name} buttonVariant={buttonVariant} isButtonDisabled={isButtonDisabled}>
      </Dropdown.Toggle>
      <Dropdown.Menu data={data} name={name} dropdownData={dropdownData} setData={setData} as={CustomMenu}>
        {dropdownData.map(dropdownItem => <Dropdown.Item key={dropdownItem}>{dropdownItem}</Dropdown.Item>)}
      </Dropdown.Menu>
    </Dropdown>
  );
};

MultiselectFilter.propTypes = {
  dropdownData: PropTypes.array.isRequired,
  multiselectedData: PropTypes.array.isRequired,
  setMultiselectedData: PropTypes.func,
  name: PropTypes.string,
  buttonVariant: PropTypes.string,
  isButtonDisabled: PropTypes.bool,
};

export default MultiselectFilter;
